import { addTrackingUrls } from '../../utils/helpers/trackingURLHelpers.js';
import { getTrackingStatus } from '../../utils/api/getTrackingStatus.js';
import { selectClasses } from '@mui/material';

export const enhanceReportRows = async (rows) => {
  const { data: withLinks } = await addTrackingUrls(rows);

  //maybe try to do some threading or speeding up but then get this to prod asap
  const enhancedRows = await Promise.all(
    withLinks.map(async ({ ["TRACKING LINK"]: trackingLink, ...rowWithoutTrackingLink }) => {
      const isVoided =
        rowWithoutTrackingLink["VOIDED"] === true ||
        rowWithoutTrackingLink["VOIDED"] === 'true' ||
        rowWithoutTrackingLink["VOIDED"] === 1 ||
        rowWithoutTrackingLink["VOIDED"] === 'TRUE';

      let status = 'Unknown';

      try {
        const statusResult = await getTrackingStatus(rowWithoutTrackingLink);
        if (statusResult && statusResult.length > 0) {
          status = statusResult[0]?.status || 'Unknown';
        }
      } catch (e) {
        console.warn(`Error getting tracking status for ${rowWithoutTrackingLink["TRACKINGNUMBER"]}:`, e);
      }
      return {
        ...rowWithoutTrackingLink,
        VOIDED_DATE: isVoided ? rowWithoutTrackingLink["SHIP_DATE"] : "N/A",
        TRACKING_LINK: (
          <a href={trackingLink} target="_blank" rel="noopener noreferrer">
            {trackingLink}
          </a>
        ),
        STATUS: status,
      };
    })
  );

  return enhancedRows;
};